export const REFRESH_TABLE = "REFRESH_TABLE";
export const REFRESH_TABLE_MESSAGE = "REFRESH_TABLE_MESSAGE";
export const REFRESH_TABLE_LOADING = "REFRESH_TABLE_LOADING";
